<div class="tier-wrapper">
  <gen-therapy-title-element
    *ngIf="therapeuticQualifier && tier == null"
    class="therapeuticQualifier Auto_Therapeutic_Qualifier"
    [subTitle]="'Variant Qualifier'"
    [value]="therapeuticQualifier"></gen-therapy-title-element>
  <div *ngIf="tier != null" class="tier-section Auto-Tier">
    <span class="tier-title Auto-Tier-Title" *ngIf="!hideLabel">Tier level</span>
    <span class="tier-content level-{{className}} Auto-Tier-Content" genTooltip [tooltipPosition]="'top'" [tooltipText]="tooltipText">
      {{tierString}}
    </span>
  </div>

</div>
